import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionTitle from "./SectionTitle";
import Reveal from "./Reveal";

export default function FAQ({ items, overline = "Perguntas Frequentes", title = "Dúvidas antes de começar", testid = "faq-section" }) {
  return (
    <section data-testid={testid} className="relative py-20 sm:py-28">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <SectionTitle overline={overline} title={title} />
        <Reveal className="mt-10" delay={0.1}>
          <Accordion type="single" collapsible className="w-full space-y-3">
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border border-white/10 rounded-2xl bg-neutral-900/50 backdrop-blur px-5 data-[state=open]:border-yellow-400/40 data-[state=open]:bg-neutral-900/80 transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left text-base sm:text-lg font-heading font-semibold text-white hover:no-underline [&[data-state=open]>svg]:text-yellow-400"
                >
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm sm:text-base text-neutral-300 leading-relaxed">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
